/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateManualDevelopmentStageDto } from '../../models/update-manual-development-stage-dto';

export interface DevelopmentStageControllerUpdateManualV1$Params {
  id: string;
      body: UpdateManualDevelopmentStageDto
}

export function developmentStageControllerUpdateManualV1(http: HttpClient, rootUrl: string, params: DevelopmentStageControllerUpdateManualV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, developmentStageControllerUpdateManualV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

developmentStageControllerUpdateManualV1.PATH = '/api/v1/development-stage/manual/{id}';
